<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { AmbientFabricBackground, UiLogo, ResponsiveImage } from '@shopexperts/shared';
import CreateProjectForm from '../components/CreateProjectForm.vue';

const route = useRoute();

// Extract expert slug from query parameter
const expertSlug = computed(() => {
  const expertParam = route.query.expert;
  return typeof expertParam === 'string' ? expertParam : undefined;
});

// Extract packaged service slug from query parameter
const packagedServiceSlug = computed(() => {
  const serviceParam = route.query.packaged_service;
  return typeof serviceParam === 'string' ? serviceParam : undefined;
});

const ctaSource = computed(() => {
  const sourceParam = route.query.cta_source;
  return typeof sourceParam === 'string' ? sourceParam : undefined;
});

const draftToken = computed(() => {
  const draftParam = route.query.draft;
  return typeof draftParam === 'string' ? draftParam : undefined;
});

// Using a placeholder image - replace with actual image path
const centeredImage = 'https://cdn.shopexperts.com/media/public/leads-form%402.png?v=2';
</script>

<template>
  <div class="min-h-screen w-screen bg-white">
    <div class="flex flex-col md:flex-row w-full h-screen">
      <!-- First Column: Form Content (35% width, min-width for mobile) -->
      <div class="w-full md:w-[35%] min-w-[320px] flex flex-col h-screen overflow-y-auto">
        <div class="flex flex-col gap-8 p-6 md:p-8">
          <!-- Header with Logo -->
          <header class="flex items-center">
            <UiLogo size="md" />
          </header>

          <!-- Create Project Form Component -->
          <CreateProjectForm
            :expert-slug="expertSlug"
            :packaged-service-slug="packagedServiceSlug"
            :source="ctaSource"
            :draft-token="draftToken"
          />
          <div class="h-12"></div>
        </div>
      </div>

      <!-- Second Column: Ambient Background with Image (hidden on mobile) -->
      <div class="hidden md:flex flex-1 h-screen relative">
        <AmbientFabricBackground :settings="{ class: 'w-full h-full' }">
          <div class="flex items-center justify-center h-full px-17 py-30">
            <ResponsiveImage 
              :src="centeredImage" 
              alt="Create Project Visual" 
              :widths="[600, 900, 1200, 1600]"
              sizes="(max-width: 768px) 0px, calc(65vw - 8.5rem)"
              class="w-full h-auto max-h-full object-contain"
            />
          </div>
        </AmbientFabricBackground>
      </div>
    </div>
  </div>
</template>
